import loadable from "@loadable/component";

const CESLanding = loadable(() => import("./CESLanding.page"));

export default { component: CESLanding };
